import React, { useState } from 'react';
import './recuperacion.css';
import { Alert, Button } from 'react-bootstrap';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const Recuperacion = () => {
  const { t } = useTranslation('recuperacion');
  const [step, setStep] = useState(1); // 1: Solicitar código, 2: Introducir código + nueva contraseña
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorKey, setErrorKey] = useState('');

  const handleRequestCode = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post('https://api.elplanmadrid.org/mailrecovery', { email });
      if (response.status === 200 || response.status === 204) {
        setStep(2);
        setErrorKey('');
        if (response.status === 204) {
          setErrorKey('error_codigo_ya_existente');
        }
      } else {
        setErrorKey('error_solicitar_codigo');
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setErrorKey('email_no_existente');
      } else {
        setErrorKey('error_red');
      }
    }
  };

  const handleChangePassword = async (event) => {
    event.preventDefault();
    if (newPassword !== confirmPassword) {
      setErrorKey('error_contrasenas_no_coinciden');
      return;
    }
    try {
      const response = await axios.post('https://api.elplanmadrid.org/recover_password', {
        email,
        password: newPassword,
        code
      });

      if (response.status === 200) {
        alert(t('contrasena_cambiada_exitosamente'));
        setStep(1);
        setEmail('');
        setCode('');
        setNewPassword('');
        setConfirmPassword('');
        setErrorKey('');
      } else {
        setErrorKey('error_cambiar_contrasena');
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        setErrorKey('error_codigo_invalido');
      } else {
        setErrorKey('error_red');
      }
    }
  };

  return (
    <main className='recovery-container'>
      <div className="recuperacion">
        <h1 className='recovery-title'>{t('recuperacion_contrasena')}</h1>
        {errorKey && <Alert variant="danger">{t(errorKey)}</Alert>}

        {step === 1 && (
          <form onSubmit={handleRequestCode} className="recovery-form">
            <div className="e-mail-input">
              <label>{t('correo_electronico')}</label>
              <input
                type="email"
                className="form-control"
                placeholder={t('introduce_correo')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <Button variant="primary" type="submit" className="code-btn mt-3">
              {t('solicitar_codigo')}
            </Button>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={handleChangePassword} className="recovery-form">
            <div className="form-group">
              <label>{t('codigo_recuperacion')}</label>
              <input
                type="text"
                className="form-control"
                placeholder={t('introduce_codigo')}
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
            </div>
            <div className="form-group mt-3">
              <label>{t('nueva_contrasena')}</label>
              <input
                type="password"
                className="form-control"
                placeholder={t('introduce_nueva_contrasena')}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>
            <div className="form-group mt-3">
              <label>{t('confirmar_nueva_contrasena')}</label>
              <input
                type="password"
                className="form-control"
                placeholder={t('confirma_nueva_contrasena')}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>
            <Button variant="primary" type="submit" className="mt-3">
              {t('cambiar_contrasena')}
            </Button>
          </form>
        )}
      </div>
    </main>
  );
};

export default Recuperacion;
